import { useHistory } from "react-router";
// components
import { Button } from "../../UI";
import { Heading1 } from "../../typography";
// icons
import { DropDownArrow } from "../../../SVGS";
// styles
import styled from "styled-components";
import { media } from "../../../styles/media";

const PageHeaderStyles = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: ${({ theme }) => theme.spacing[20]};
  border-bottom: 1px solid ${({ theme }) => theme.colors.semantic.separator};

  .headerActions {
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.spacing[16]};
    margin-left: auto;
  }

  .backButton {
    padding: ${({ theme }) => theme.spacing[8]} ${({ theme }) => theme.spacing[12]};
    display: flex;
    align-items: center;
    margin-right: ${({ theme }) => theme.spacing[24]};

    .arrowContainer {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: ${({ theme }) => theme.spacing[8]};
      transform: rotate(-90deg);
      padding-top: 2.5px;
    }
  }

  /* Stack title and actions on phones so the action buttons get a full row
     instead of being squeezed beside the title. */
  ${({ theme }) => media.maxMobile`
    flex-wrap: wrap;
    gap: 12px;

    .headerActions {
      margin-left: 0;
      width: 100%;
      flex-wrap: wrap;
    }
  `}
`;

const PageHeader = ({ title, showBack, children }) => {
  const history = useHistory();
  return (
    <PageHeaderStyles>
      {showBack && (
        <Button onClick={() => history.goBack()} className="backButton">
          <div className="arrowContainer">
            <DropDownArrow />
          </div>
          Back
        </Button>
      )}
      <Heading1>{title}</Heading1>
      {children && <div className="headerActions">{children}</div>}
    </PageHeaderStyles>
  );
};

export default PageHeader;
